import { useCustomThemeContext } from "components/App/CustomThemeProvider";
import { useEffect } from "react";

const useBaseCss = () => {
  const themeContext = useCustomThemeContext();

  useEffect(() => {
    if (themeContext.baseCssUrl) {
      const link = document.getElementById("organization-base-css") as HTMLLinkElement;

      if (link && link.href !== themeContext.baseCssUrl) {
        link.href = themeContext.baseCssUrl;
      }
    }
  }, [themeContext]);
};

export default useBaseCss;
